import faker from 'faker'
import _ from 'lodash'
import moment from 'moment'
import hres6nuLabels from 'assets/labels/hres6nu'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres6nuLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        staappr: '',
        codempid: faker.finance.mask(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        numseq: faker.random.number().toString().substr(0, 1),
        desc_codleave: faker.lorem.words(),
        dteperiod: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year() + '- ' + moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        desc_codcomp: faker.lorem.words(),
        desc_codpos: faker.lorem.words(),
        status: faker.lorem.words(),
        desc_codappr: faker.name.findName(),
        dteappr: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        remark: faker.lorem.words(),
        desc_codempap: faker.name.findName()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
      codleave: faker.finance.mask(),
      desc_codleave: faker.name.findName(),
      dtestrt: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
      dteend: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
      remark: faker.lorem.word()
    }

    return {
      tab1: mockTab1
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6nu/mocker.js